import { createJSONRequest, createResource } from './create-request'

export const Feeds = createResource('/api/settings/feeds')

export const updateNewsOutlet = (params) => createJSONRequest({
  method: 'PUT',
  url: `/api/settings/update-news-outlet`,
  data: params,
})
